import { Link } from 'react-router-dom';
import { useIsMobileNav } from '@/hooks/utils/use-mobile';

interface FooterProps {
  hideLinks?: boolean;
}

export function Footer({ hideLinks = false }: FooterProps) {
  const isMobileNav = useIsMobileNav();
  return (
    <footer className={`mt-12 bg-muted/30 border-t border-border ${isMobileNav ? 'pb-20' : 'pb-8'}`}>
      <div className="container mx-auto px-4 py-8">
        <div className={`${isMobileNav ? 'space-y-6' : hideLinks ? 'grid grid-cols-1 md:grid-cols-2 gap-8 items-center' : 'grid grid-cols-1 md:grid-cols-3 gap-8 items-center'}`}>
          <div className={`${isMobileNav ? 'text-center' : 'md:text-left'}`}>
            <div className="flex items-center gap-2 mb-3 justify-center md:justify-start">
              <img src="/icons/crowdfpl-icon.svg" alt="CrowdFPL" className="h-6 w-6" />
              <span className="text-lg font-semibold text-foreground">CrowdFPL</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-sm mx-auto md:mx-0">
              Trust the wisdom of the crowd to make better Fantasy Premier League decisions every Gameweek.
            </p>
          </div>

          {!hideLinks && (
            <div className={`${isMobileNav ? 'flex flex-wrap justify-center gap-x-6 gap-y-2' : 'md:text-center'}`}>
              <Link to="/blog" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium h-9 px-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                Blog
              </Link>
              <Link to="/how-it-works" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium h-9 px-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                How it works
              </Link>
              <Link to="/rating" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium h-9 px-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                Rating
              </Link>
              <Link to="/captain-rating" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium h-9 px-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                Captain Rating Rules
              </Link>
              <Link to="/how-leagues-work" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium h-9 px-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                Leagues
              </Link>
              <Link to="/terms" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium h-9 px-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                Terms
              </Link>
              <Link to="/privacy-policy" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium h-9 px-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                Privacy
              </Link>
            </div>
          )}

          <div className={`${isMobileNav ? 'text-center' : 'md:text-right'}`}>
            <a
              href="mailto:support@crowdfpl.com"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              support@crowdfpl.com
            </a>
            <p className="text-xs text-muted-foreground mt-2">© {new Date().getFullYear()} CrowdFPL. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
